/**
 * handle return action from amp pipe with next status populate and isNextStatusIsPipeIsMatching (out/refused status)
 * @param {Object} managementProcess
 * @returns {Array} [{action}]
 */
export const getActionsFromAmp = ({ managementProcess }) => {
  if (managementProcess && Array.isArray(managementProcess.pipes)) {
    return managementProcess.pipes.reduce((prev, current) => {
      const actionsWithNextStatusPopulate = current.actions.map((action) => {
        if (action.nextStatus) {
          managementProcess.pipes.map((p) =>
            p.status.map((s) => {
              if (s.key === action.nextStatus) {
                action.nextStatus = s;
                action.isNextStatusIsPipeIsMatching = p.isMatching;
              }
            })
          );
        }
        if (action.nextStatus2) {
          managementProcess.pipes.map((p) =>
            p.status.map((s) => {
              if (s.key === action.nextStatus2) {
                action.nextStatus2 = s;
              }
            })
          );
        }
        return action;
      });
      return [...prev, ...actionsWithNextStatusPopulate];
    }, []);
  }
  return [];
};

/**
 * sort actions to put action out/refused lastest
 * @param {Array} actions array of action from amp pipe
 */
export const sortActionsByNextStatusIsInPipeIsMatching = ({ actions }) =>
  actions.sort((a, b) => {
    if (a.isNextStatusIsPipeIsMatching > b.isNextStatusIsPipeIsMatching) {
      return -1;
    } else if (a.isNextStatusIsPipeIsMatching < b.isNextStatusIsPipeIsMatching) {
      return 1;
    }
    return 0;
  });

/**
 * fetch action send_sms and send_mail into communicationActions array
 * other action into normalActions array
 * @param {Array} actions array of action from amp pipe
 */
export const fetchActionByCommunication = ({ actions }) => {
  const objReturn = {
    communicationActions: [],
    normalActions: [],
  };
  actions.forEach((action) => {
    if (
      action?.nextStatus?.actions?.some((a) => a === "send_sms" || a === "send_mail") ||
      action?.nextStatus2?.actions?.some((a) => a === "send_sms" || a === "send_mail")
    ) {
      objReturn.communicationActions.push(action);
    } else {
      objReturn.normalActions.push(action);
    }
  });
  return objReturn;
};

/**
 * handle return disable boolean with condition :
 *  - empty selectedApplies
 *  - action have conditions (status) selectedApplies has some apply without those status
 *  - action is not isMultipleAction selectedApplies length is more than 1
 * @param {Array} action  action from amp pipe
 * @param {Array} selectedApplies selected applies
 * @returns {Boolean}
 */
export const isDisabledAction = ({ action, selectedApplies, isLoading }) =>
  !Array.isArray(selectedApplies) ||
  !selectedApplies.length ||
  (action.conditions.length && selectedApplies.some((apply) => !action.conditions.includes(apply.status))) ||
  (!action.isMultipleAction && selectedApplies.length > 1) ||
  isLoading ||
  selectedApplies.some((apply) => action.nextStatus.key === apply.status);

export const isDisabledOptInPhone = ({ selectedApplies }) =>
  selectedApplies.some((apply) => !apply?.candidate?.optInPhone);
